import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { ApiFeatureInfoServiceResponse } from "./types";

export const featureInfoEndpoint = (url: string): AxiosPromise<ApiFeatureInfoServiceResponse> =>
    apiWrapper.instance!.get(`rest/gis/featureInfo?${url}`);
